import React, { useState, useEffect } from "react";
import { Input, List } from "antd";

function AddressInput({ form, formData, setFormData }) {
  const [suggestedAddresses, setSuggestedAddresses] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [inputValue, setInputValue] = useState(formData.aAdress || "");
  useEffect(() => {
    setInputValue(formData.aAdress || "");
  }, [formData.aAdress]);

  const handleAddressSearch = async (value) => {
    if (!value || value.length < 4) {
      setSuggestedAddresses([]);
      setShowSuggestions(false);
      return;
    }

    const url = `https://nominatim.openstreetmap.org/search.php?q=${encodeURIComponent(
      value
    )}&polygon_geojson=1&format=jsonv2`;

    try {
      const res = await fetch(url);
      const data = await res.json();
      setSuggestedAddresses(data || []);
      setShowSuggestions(true);
    } catch (err) {
      console.error(err);
      setSuggestedAddresses([]);
      setShowSuggestions(false);
    }
  };

  const handleSelectSuggestion = (suggestion) => {
    setInputValue(suggestion.display_name);
    setFormData((prev) => ({
      ...prev,
      aAdress: suggestion.display_name,
      cordinateReq: `${suggestion.lat},${suggestion.lon}`,
    }));
    form.setFieldsValue({ aAdress: suggestion.display_name }); 
    setShowSuggestions(false);
  };

  return (
    <div style={{ position: "relative", marginBottom: 16 }}>
      <Input
      className="address-input"
        placeholder="Indirizzo punto vendita"
        value={inputValue}
        onChange={(e) => {
          const val = e.target.value;
          setInputValue(val);
          setFormData((prev) => ({ ...prev, aAdress: val }));
          form.setFieldsValue({ aAdress: val }); 
        }}
        suffix={
          <i
            className="fal fa-search"
            style={{ cursor: "pointer" }}
            onClick={() => handleAddressSearch(inputValue)}
          />
        }
      />

      {showSuggestions && suggestedAddresses.length > 0 && (
        <List
          bordered
          size="small"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            maxHeight: 200,
            overflowY: "auto",
            background: "#fff",
            zIndex: 10,
          }}
          dataSource={suggestedAddresses}
          renderItem={(item) => (
            <List.Item
              key={item.place_id}
              onClick={() => handleSelectSuggestion(item)}
              style={{ cursor: "pointer" }}
            >
              {item.display_name}
            </List.Item>
          )}
        />
      )}
    </div>
  );
}

export default AddressInput;
